import { render, staticRenderFns } from "./ProveedoresClone.vue?vue&type=template&id=4458c818&"
import script from "./ProveedoresClone.vue?vue&type=script&lang=js&"
export * from "./ProveedoresClone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports